import { EnumEntity } from '../entity'

export class ExpenseCategory extends EnumEntity {
  id: number
}
